import React from 'react'
import {
  PixelCurrency,
  PixelDate,
  PixelFactoryContext,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
  SectionTitle,
} from 'pixel-base'
import styled from 'styled-components'

import { InvoicePaymentsDetails } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../decl.d'

const columns = [
  {
    dataKey: 'booking_date',
    name: 'Booking Date',
    sortable: true,
    selector: (row) => <PixelDate value={row.booking_date} />,
  },
  {
    dataKey: 'consignee',
    name: 'Consignee',
    selector: (row) => row.consignee || '--',
  },
  {
    dataKey: 'consignment_tracking_no',
    name: 'Consignment Tracking No',
    selector: (row) => row.consignment_tracking_no || '--',
  },
  {
    dataKey: 'weight',
    name: 'Weight',
    selector: (row) => row.weight || '--',
  },
  {
    dataKey: 'delivery_status',
    name: 'Delivery Status',
    selector: (row) => row.delivery_status || '--',
  },
  {
    dataKey: 'cod_amount',
    name: 'COD Amount',
    selector: (row) => <PixelCurrency value={row.cod_amount} />,
  },
  {
    dataKey: 'shipping_chg',
    name: 'Shipping Charges',

    selector: (row) => <PixelCurrency value={row.shipping_chg} />,
  },
]

const PaymentInvoicesDetail = (props) => {
  const { payment_id } = props

  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const headerRef = React.useRef(null)
  const [invoicePaymentsDetails, setInvoicePaymentsDetails] =
    React.useState<any>()
  const [details, setDetails] = React.useState([])

  React.useEffect(() => {
    if (payment_id == null) return
    getPaymentInvoicesDetail(payment_id)
  }, [payment_id])

  const getPaymentInvoicesDetail = (id) => {
    showLoader(headerRef)
    InvoicePaymentsDetails(id).subscribe((res: any) => {
      setInvoicePaymentsDetails(res.response.data)
      setDetails(res.response.data['details'])
      hideLoader(headerRef)
    })
  }

  return (
    <>
      <PixelPageContainer>
        <Section>
          <SectionTitle>Summary Header</SectionTitle>
          <SectionContent ref={headerRef}>
            <InfoItem>
              <Label>Invoice Name:</Label>
              <Detail>
                {invoicePaymentsDetails?.header?.invoice_name || '--'}
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>Invoice Amount:</Label>
              <Detail>
                <PixelCurrency
                  value={invoicePaymentsDetails?.header?.invoice_amount || '--'}
                />
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>GST:</Label>
              <Detail>
                <PixelCurrency value={invoicePaymentsDetails?.header?.gst} />
              </Detail>
            </InfoItem>

            <InfoItem>
              <Label>Arears:</Label>
              <Detail>
                <PixelCurrency
                  value={invoicePaymentsDetails?.header?.arears || '--'}
                />
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>Fuel Charges:</Label>
              <Detail>
                <PixelCurrency
                  value={invoicePaymentsDetails?.header?.fuel_charges}
                />
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>Cash Handling Charges:</Label>
              <Detail>
                <PixelCurrency
                  value={invoicePaymentsDetails?.header?.cash_handling_charges}
                />
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>Shipping or Weight Charges:</Label>
              <Detail>
                <PixelCurrency
                  value={
                    invoicePaymentsDetails?.header
                      ?.shipping_or_weight_charges || '--'
                  }
                />
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>Other Charges:</Label>
              <Detail>
                <PixelCurrency
                  value={invoicePaymentsDetails?.header?.other_charges || '--'}
                />
              </Detail>
            </InfoItem>

            <InfoItem>
              <Label>Courier Name:</Label>
              <Detail>
                {invoicePaymentsDetails?.header?.courier_name || '--'}
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>Invoice Reference:</Label>
              <Detail>
                {invoicePaymentsDetails?.header?.invoice_reference || '--'}
              </Detail>
            </InfoItem>
            <InfoItem>
              <Label>EMS Load Date:</Label>
              <Detail>
                <PixelDate
                  color="#8e959b"
                  value={invoicePaymentsDetails?.header?.ems_load_date || '--'}
                  format={'pixelStandard'}
                ></PixelDate>
              </Detail>
            </InfoItem>

            <InfoItem>
              <Label>Uploaded By:</Label>
              <Detail>
                {invoicePaymentsDetails?.header?.uploaded_by || '--'}
              </Detail>
            </InfoItem>
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>Details</SectionTitle>
          <SectionContent>
            <PixelTable
              columns={columns}
              fixedHeader
              fixedHeaderScrollHeight="calc(100vh - 610px)"
              data={details}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

const InfoItem = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;

  &:last-child {
    border-bottom: none;
  }
`

const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #8e959b;
  display: table-cell;
  vertical-align: middle;
  padding-right: 10px;
  /* padding: 10px; */
  /* background-color: #e9ecef; */
  width: 40%;
`

const Detail = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #8e959b;
  display: table-cell;
  vertical-align: middle;
  padding-left: 10px;
  width: 60%;
  /* background-color: #11131678; */
`
export default PaymentInvoicesDetail
